import React from 'react';

const BankSelect = (props) => {
  return (
    <div className="form-group">
      <div className="input-group">
        <select id="issuerId" className="bank-select" data-checkout="issuer" onChange={props.handleOnChange}>
          <option value="" disabled selected>Select Bank</option>
          {props.issuers.map((e) => {
            return <option key={e.issuer.id} value={e.issuer.id}>{e.issuer.name}</option>;
          })}
        </select>
      </div>
    </div>
  );
}

export default BankSelect;